import React, { useMemo } from 'react'
import _ from 'lodash'
import Wrapper, { wrapperTypes } from '../../../../global/wrappers/Wrapper'

export const MatchPointHistory = ({ matchRealTime }) => {

  const mrt = matchRealTime ? _.head(_.values(matchRealTime)) : {}
  const { tracker } = mrt ?? {}
  const { pointHistory } = tracker ?? {}

  const histories = useMemo(() => {
    if (pointHistory) {
      const phs = _.reverse(
        _.map(pointHistory, (ph) => {
          const { away, home, selectedStat, winner, setNumber } = ph;
          const { stat, selectedPlayer } = selectedStat ?? {};
          const { lastName, firstName, uniformNumber } = selectedPlayer ?? {};
          let statDisplay;
          switch (stat) {
            case 'OTE':
            case 'NS':
              statDisplay = stat
              break;
            default:
              statDisplay = <div><div>{stat + ' - ' + uniformNumber}</div> <div>{firstName + ' ' + lastName}</div></div>
          }
          return (
            <div>
              <div>{away}</div>
              <div>
                {winner === 'away' ?
                  statDisplay : ''}
              </div>
              <div>{setNumber}</div>
              <div>
                {winner === 'home' ?
                  statDisplay : ''}
              </div>
              <div>{home}</div>
            </div>
          );
        }).slice() // clone before reversing
      );
      phs.unshift(
        <div>
          <div>{'Away'}</div>
          <div>{'Away Stat'}</div>
          <div>{'Set'}</div>
          <div>{'Home Stat'}</div>
          <div>{'Home'}</div>
        </div>
      )
      return <div className='point-histories'>
        {phs}
      </div>
    }
  }, [pointHistory]);

  return (
    <Wrapper
      header={'Point History'}
      content={histories}
      wrapperType={wrapperTypes.padded}
    />
  )
}
